<template>
  <div class="uk-flex uk-flex-column uk-flex-center uk-flex-middle grid-background main-container">
    <div class="uk-card uk-card-default uk-flex-middle card-width mobile-land-up-card">
      <div class="uk-text-center uk-text-large uk-text-bolder uk-margin-top">
        <img
          class="login-icon uk-padding uk-flex"
          style="height: 100%; width: 100%; object-fit: contain"
          src="/icons/Official-OpenVetting-Logo-Light.png"
        />
      </div>
      <div class="uk-text-center">
        <h5
          v-if="status !== 'decline' && !showTooLate && !isDecline"
          class="uk-text-bold font-color"
        >
          Join the debate!
        </h5>
        <h5 v-else-if="status === 'decline' || isDecline" class="uk-text-bold font-color">
          Regrets...
        </h5>
        <h5 v-else-if="showTooLate" class="uk-text-bold font-color">The challenge has been met</h5>
      </div>
    </div>
    <div
      class="uk-card uk-card-default card-width uk-margin-top card-padding mobile-land-bottom-card"
    >
      <div v-if="((status === 'accept' && joinDebatePage) || acceptBtnShow) && !isDecline">
        <div v-if="invitationsPermissionLevel === PermissionLevel.TEAM_LEAD">
          <div v-if="requestedPrivacyLevel === 'Optional'">
            <p class="font-color uk-text-small">
              {{ status ? invitations?.invitedBy?.firstname : challengeDetails?.host?.first_name }}
              has deferred to you on confidentiality.
            </p>
            <div class="privacy-options">
              <form-group v-for="option in privacyOptions" :key="option.value">
                <label class="uk-text-small">
                  <input
                    class="uk-radio"
                    type="radio"
                    v-model="privacySelection"
                    :value="option.value"
                  />
                  <span class="uk-margin-small-left" v-html="option.label"></span>
                </label>
              </form-group>
            </div>
          </div>
          <p v-else-if="requestedPrivacyLevel === 'Private'" class="font-color uk-text-small">
            {{ status ? invitations?.invitedBy?.firstname : challengeDetails?.host?.first_name }}
            has asked this discussion be kept confidential.
          </p>
          <p v-else class="uk-text-small font-color">
            In the interest of public learning, discussions on OpenVetting are shareable via social
            media.
          </p>
        </div>
        <div v-if="invitationsPermissionLevel === PermissionLevel.COHORT">
          <p v-if="requestedPrivacyLevel === 'Private'" class="font-color">
            {{ status ? invitations?.invitedBy?.firstname : challengeDetails?.host?.first_name }}
            has asked this discussion be kept confidential.
          </p>
        </div>
      </div>
      <h6 v-else-if="isDecline || status === 'decline'">
        <p class="uk-text-center font-color">
          We’re sorry this OpenVetting debate was not of interest
        </p>
        <p class="uk-text-center font-color">
          We hope to include your thoughts in the future on another topic.
        </p>
        <p class="uk-text-center font-color">
          Click here to <a href="https://openvetting.ai/"><b>learn</b></a> more.
        </p>
      </h6>
      <h6 v-else-if="isAccept || mobileStaticPage">
        <p>Thank you for agreeing to participate in the discussion.</p>
        <p>
          Because of the detailed nature of OpenVetting discussions, our debates do not currently
          support a mobile environment.
        </p>
        <p>
          Please login on your desktop or laptop device at the first opportunity to continue the
          discussion.
        </p>
      </h6>
      <h6 v-else-if="showTooLate">
        <p>
          Thank you for your interest in "{{
            status ? invitations?.document?.title : challenges?.document?.title
          }}." Unfortunately that invitation has already been accepted.
        </p>
        <p>We hope to include your thoughts in the future!</p>
        <p>
          Click here to <a href="https://openvetting.ai/"><b>learn</b></a> more.
        </p>
      </h6>

      <h6 v-else-if="challengeDetailsMainPage">
        <p>
          {{ challengeDetails?.host?.first_name }}
          {{
            challengeDetails?.host?.my_affiliation !== null
              ? `of ${challengeDetails?.host?.my_affiliation}`
              : challengeDetails?.host?.last_name
          }}
          {{
            challengeDetails?.debate?.initialStance === 'Host'
              ? 'defend'
              : 'critique their thinking'
          }}
          in a discussion called "{{ challengeDetails?.debate?.title }}" based on "{{
            challengeDetails?.debate?.articleTitle
          }}."
        </p>
        <p>Please sign in to continue</p>
      </h6>
      <h6 v-else>
        <p>
          To elevate the best ideas on both sides, the discussion will occur on the OpenVetting
          Forum, using AI, threaded markup and visual logic.
        </p>
        <p>
          <a href="https://openvetting.ai/">Learn more at</a>
        </p>
        <p>Please sign in to continue</p>
      </h6>
    </div>
    <div>
      <div v-if="status === 'accept' && joinDebatePage && !mobileViewRespons">
        <LoaderButton
          class="uk-button uk-flex-center uk-button-primary uk-margin-large-top uk-text-bold btn-border"
          :loaderStatus="acceptSavingStatus"
          @click="register()"
        >
          {{ 'Next' }}
        </LoaderButton>
      </div>
      <div v-else-if="acceptBtnShow && !isDecline">
        <LoaderButton
          class="uk-flex-center uk-button uk-button-primary uk-button-large uk-margin-large-top uk-text-bold btn-border mobile-btn-margin"
          :loaderStatus="acceptSavingStatus"
          @click="doSubmitClick()"
        >
          {{ 'Accept' }}
        </LoaderButton>
        <LoaderButton
          class="uk-flex-center uk-button uk-button-primary uk-button-large uk-margin-large-top uk-text-bold btn-border mobile-btn-margin"
          :loaderStatus="declineSavingStatus"
          @click="doDeclineClick()"
        >
          {{ 'Decline' }}
        </LoaderButton>
      </div>
      <LoaderButton
        v-else-if="
          !isAccept && !mobileStaticPage && status !== 'decline' && !showTooLate && !isDecline
        "
        class="uk-flex-center uk-button uk-button-primary uk-button-large uk-margin-large-top uk-text-bold btn-border"
        :loaderStatus="loadingStatus"
        @click="SignIn"
      >
        {{ 'Sign In' }}
        <span uk-icon="icon: arrow-right"></span>
      </LoaderButton>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import LoaderButton from '@/components/display/button/LoaderButton.vue';
import PermissionLevel from '@/assets/js/enum/PermissionLevel';
import UIkit from 'uikit';
export default {
  name: 'MobileLandingPage',

  components: {
    LoaderButton,
  },
  data() {
    return {
      reminderTimeOptions: [
        {
          label: '1 Hours',
          value: 1,
        },
        {
          label: '4 Hours',
          value: 4,
        },
        {
          label: '8 Hours',
          value: 8,
        },
        {
          label: '1 Days',
          value: 24,
        },
      ],
      date: null,
      time: null,
      privacySelection: 'Public',
      privacyOptions: [
        {
          label: 'Enable sharing',
          value: 'Public',
        },
        {
          label: 'Prefer confidentiality',
          value: 'Private',
        },
      ],
    };
  },
  props: {
    joinDebatePage: {
      type: Boolean,
      defualt: true,
    },
    isAccept: {
      type: Boolean,
      defualt: false,
    },
    isDecline: {
      type: Boolean,
      defualt: false,
    },
    joinDebate: {
      type: Boolean,
      defualt: false,
    },
    mobileViewRespons: {
      type: Boolean,
      defualt: false,
    },
    showTooLate: {
      type: Boolean,
      defualt: false,
    },
    mainPage: {
      type: Boolean,
      defualt: false,
    },
    challengeDetailsMainPage: {
      type: Boolean,
      defualt: false,
    },
    acceptBtnShow: {
      type: Boolean,
      defualt: false,
    },
    declineStatus: String,
    acceptSavingStatus: String,
    declineSavingStatus: String,
    loadingStatus: String,
    invitations: Object,
    inviteBy: Object,
    document: Object,
    status: String,
    requestedPrivacyLevel: String,
    challenges: Object,
  },
  emits: ['signIn'],
  computed: {
    ...mapState([
      'userData',
      'idToken',
      'acceptDecline',
      'mobileStaticPage',
      'challengeDetails',
      'challengeUrl',
    ]),

    ...mapGetters(['getAdjustedTime', 'permissionLevel']),
    PermissionLevel() {
      return PermissionLevel;
    },
    invitationsPermissionLevel() {
      return this.status ? this.invitations?.permissionLevel : this.challenges?.permissionLevel[0];
    },
  },
  mounted() {
    // this.setDateAndTimeFromThreshold(this.invitations?.timeThreshold)
  },
  methods: {
    ...mapMutations(['setAcceptDecline']),
    SignIn() {
      this.$emit('signIn');
    },
    register() {
      this.setAcceptDecline(false);
    },
    doAcceptClick() {
      this.$emit('doAcceptClick');
    },
    doDeclineClick() {
      this.$emit('doDeclineClick');
    },
    doReminderClick(time) {
      UIkit.dropdown(this.$refs.reminderDropdown).hide();
      this.$emit('doReminderClick', time);
    },
    doSubmitClick() {
      this.$emit('submit', this.privacySelection);
    },
    objctUrl() {
      window.location.href = 'https://openvetting.ai/';
    },
    setDateAndTimeFromThreshold(threshold) {
      let currDate = new Date(this.invitations?.createdAt);
      const formDate = this.getAdjustedTime(currDate, threshold);
      this.setFormattedDateTime(formDate);
    },
    setFormattedDateTime(dateToFormat) {
      //
      // Format date
      // we need a local date first, in order for the ISO format conversion not to change the timezone
      let localeDate = dateToFormat.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
      const date = new Date(localeDate)?.toISOString()?.split('T')[0];
      //
      // Format time
      const time = dateToFormat.toLocaleTimeString(
        'en-US', // GB locale format used in order to get time in 24-hour format,
        // (rather than the AM/PM we get from the US format)
        { hour: '2-digit', minute: 'numeric', hour12: true }
      );

      this.date = date;
      this.time = time;
    },
  },
};
</script>
<style lang="sass">
.main-container
    text-align: -webkit-center
    min-height: 100vh
.card-width
    width: 70%
.dropdown-width
    width: 80% !important
    border: 2px solid #5baed3
.login-icon-mobile
    height: 5rem
.btn-border
    border: 3px solid !important
.remind-dropdown
    border: 2px solid ligtblue !important
.reminder-li
    padding: 5px
    font-size: $global-large-font-size
    border-bottom: 1px solid
.reminder-li-last
    font-size: $global-large-font-size
.card-padding
    padding: 7px 7px
.btn-decline-color
    background-color: gray !important

.toggle-btn
    border: 5px solid white
.white-btn
    background-color: white
.border-btn
    border: 2px solid
    border-radius: 7px
.height-btn
    min-height: 41px

.registerText
    color: #517f91
    font-weight: bold
    &:hover
      text-decoration: underline
.mobile-land-up-card
    border-radius: 15px 15px 0 0
.mobile-land-bottom-card
    border-radius: 0 0 15px 15px
    padding: 10%
.font-color
    color: #254858
.mobile-btn-margin
    margin: 5px !important
</style>
